import React, { useState, useEffect } from 'react';
import './home.css';

const roles = [
  'Data Analyst',
  'ML Engineer',
  'Full Stack Developer',
  'Tech Enthusiast'
];

const Hero = () => {
  const [currentRole, setCurrentRole] = useState(0);
  const [displayText, setDisplayText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [charIndex, setCharIndex] = useState(0);

  useEffect(() => {
    const currentText = roles[currentRole];
    let timeout;

    if (!isDeleting && charIndex < currentText.length) {
      timeout = setTimeout(() => {
        setDisplayText(currentText.substring(0, charIndex + 1));
        setCharIndex(charIndex + 1);
      }, 80);
    } else if (!isDeleting && charIndex === currentText.length) {
      timeout = setTimeout(() => setIsDeleting(true), 2000);
    } else if (isDeleting && charIndex > 0) {
      timeout = setTimeout(() => {
        setDisplayText(currentText.substring(0, charIndex - 1));
        setCharIndex(charIndex - 1);
      }, 40);
    } else if (isDeleting && charIndex === 0) {
      setIsDeleting(false);
      setCurrentRole((prev) => (prev + 1) % roles.length);
    }

    return () => clearTimeout(timeout);
  }, [charIndex, isDeleting, currentRole, roles]);

  const stats = [
    { number: '30+', label: 'Projects Built' },
    // { number: '9.41', label: 'CGPA' },
    { number: '4+', label: 'Internships' },
  ];

  return (
    <section className="hero" id="home">
      <div className="hero__glow"></div>
      <div className="hero__glow hero__glow--secondary"></div>
      
      <div className="hero__container container">
        <div className="hero__content">
          <div className="hero__greeting">
            <span className="hero__greeting-line"></span>
            <span className="hero__greeting-text">Hello, I'm</span>
          </div>

          <h1 className="hero__name">
            Harshvardhan
            <span className="hero__name-accent"> Sharma</span>
          </h1>

          <div className="hero__role">
            <span className="hero__role-prefix">&gt;_</span>
            <span className="hero__role-text">{displayText}</span>
            <span className="hero__role-cursor">|</span>
          </div>

          <p className="hero__description">
            A passionate and dedicated Tech enthusiast with knowledge of Data Analytics, Machine Learning and Full Stack Web Development, building impactful solutions.
          </p>

          <div className="hero__actions">
            <a href="#contact" className="btn btn--primary" id="hero-contact-btn">
              <span>Get in Touch</span>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.43 5.93L20.5 12L14.43 18.07" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M3.5 12H20.33" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
            <a href="#projects" className="btn btn--outline" id="hero-projects-btn">
              <span>View Projects</span>
            </a>
          </div>

          <div className="hero__social">
            <a href="https://www.linkedin.com/in/harshvardhan-sharma-88b414256" className="hero__social-link" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <i className="bx bxl-linkedin-square"></i>
            </a>
            <a href="https://github.com/Harshvardhan2164" className="hero__social-link" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <i className="bx bxl-github"></i>
            </a>
            <a href="https://www.instagram.com/hvs_harshvardhan21" className="hero__social-link" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <i className="bx bxl-instagram"></i>
            </a>
            <a href="https://www.kaggle.com/harshvardhan21" className="hero__social-link" target="_blank" rel="noopener noreferrer" aria-label="Kaggle">
              <i className="fa-brands fa-kaggle"></i>
            </a>
          </div>
        </div>

        <div className="hero__stats">
          {stats.map((stat, index) => (
            <div className="hero__stat" key={index} style={{ animationDelay: `${0.5 + index * 0.15}s` }}>
              <span className="hero__stat-number">{stat.number}</span>
              <span className="hero__stat-label">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="hero__scroll">
        <a href="#about" className="hero__scroll-link">
          <span className="hero__scroll-text">Scroll Down</span>
          <div className="hero__scroll-indicator">
            <div className="hero__scroll-dot"></div>
          </div>
        </a>
      </div>
    </section>
  );
};

export default Hero;
